import { createFileRoute } from '@tanstack/react-router'
import { StaffPertanahan } from '../../../../components/StaffPertanahan'

export const Route = createFileRoute('/platform/desa/$desaId/pertanahan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffPertanahan desaId={desaId} />
  },
})
